<template>
  <div class="main">
    <div class="notification is-info" v-if="logEmpty">Log is empty.</div>

    <div class="gamecam-log"
      v-if="logEmpty == false">
      <h2 class="subtitle is-6">Most recent log entries</h2>
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th>Timestamp</th>
            <th>Log entry</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="logEntry in log" :key="logEntry.timeStamp">
            <td class="timestamp-cell">
              <span>{{ logEntry.timeStamp }}</span>
            </td>
            <td>
              <span>{{ logEntry.text }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { GET_LOG } from "./gamecamStore";

export default {
  name: "GamecamLogTab",
  components: {},

  props: {
    gamecamStorePath: {
      type: String,
      required: true,
    },
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},

  computed: {
    logEmpty() {
      if (!this.log) {
        return true;
      }

      return this.log.length == 0;
    },

    log() {
      const getLog = `${this.gamecamStorePath}/${GET_LOG}`;
      return this.$store.getters[getLog];
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.main {
  overflow: auto;
  padding: 10px;
}

.gamecam-log {
  .subtitle {
    margin-bottom: 0;
  }

  .timestamp-cell {
    span {
      white-space: nowrap;
    }
  }
}
</style>
